import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { WHATSAPP_NUMBER, WH_LINK } from 'shared/constants'
import WaImage from 'shared/images/wa-banner.webp'
import { openExternalUrl } from 'shared/lib/external-open'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { Button } from 'shared/ui/button'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

export const FeedBackBanner = () => {
  const { t } = useTranslation()

  const btnHandler = () => {
    openExternalUrl(`${WH_LINK}${WHATSAPP_NUMBER}`)
  }

  return (
    <div className={s.banner}>
      <ImageLazy
        src={WaImage}
        className={s.image}
        alt={'image'}
      />

      <AppIcon
        width={30}
        height={30}
        id={AllIcons.WHATSAPP}
        className={s.waIcon}
        color={'#fff'}
      />

      <p className={clsx('bold-22', s.text)}>{t('feed_back.wa_answer')}</p>

      <Button
        className={s.waButton}
        type={'button'}
        onClick={btnHandler}
      >
        {t('feed_back.open_chat')}
        <AppIcon
          width={25}
          height={24}
          id={AllIcons.ARROW_RIGHT_LONG}
          className={s.icon}
        />
      </Button>
    </div>
  )
}
